export default (that) => [
  {
    title: '',
    field: 'pdProcessDictStep',
    width: 100,
    mergeByKey: true,
    visible: false,
  },
  {
    title: that.$l('table_label_pdProcessDictStep') || '工序',
    field: 'v_pdProcessDictStep',
    width: 100,
    align: 'center',
    merge: true,
    fixed: 'left',
  },
  {
    title: that.$l('table_label_techGroupName') || '工艺及单位',
    align: 'center',
    fixed: 'left',
    children: [
      {
        title: that.$l('table_label_techName') || '工艺',
        field: 'techName',
        minWidth: 200,
        headerAlign: 'center',
        align: 'left',
      },
      {
        title: that.$l('table_label_techChargeUnit') || '计价单位',
        field: 'techChargeUnitText',
        width: 95,
        align: 'center',
      },
    ],
  },
]
